module.exports = __webpack_public_path__ + "img/上传.d4a15f02.png";